<template>
  <div dir="ltr" class="product__box">
    <v-row no-gutters class="mt-10 d-flex justify-center">
      <v-col align-self="left" class="mt-8" cols="12" lg="6" md="12" xl="6" sm="12" v-for="(item,index) in products" :key="index">
       <router-link style="text-decoration: none" :to="'/sub/light-blocks/construction/product/'+item.en">
         <v-row justify="center" align="end">
           <v-img max-width="30%" height="30%" :src="item.img"/>
           <div class="product__name">{{item.pr}}</div>
         </v-row>
       </router-link>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "products",
  computed:{
    ...mapState({
      products:state => state.lightBlocksManagement.products,
    })
  }
}
</script>

<style scoped lang="scss">
.product {
  &__box {
    // background: #FCC300;
    width: 100vw;
    padding: 64px;
  }
  &__name{
    clip-path: polygon(0 0, 93% 0, 100% 41%, 0 41%);
    height: 70px;
    background: #7BAD32;
    width: 240px;
    text-align: right;
    padding-right: 20px;
    color: #FFFFFF;
    padding-top: 2px;
    text-decoration: none;
  }
}
</style>